import React from "react";

const Required = ({ value }) => value ? <span className="required-displayer">*</span> : null;

export default Required;
